import React, { useState, useEffect } from "react";
import axios from "axios";
import data from "../assets/apiRoutes.json";
import { connect } from "react-redux";
import { CheckBox, SelectBox, Popup, Button as DevExtremeButton, TextBox } from 'devextreme-react';
import { GridLayout } from "../common/GridLayout";
import {alert, confirm} from 'devextreme/ui/dialog';
import { LoadPanel } from 'devextreme-react/load-panel';

var currentLayout = "Default";
const GridLayoutManager = (props) => {

    var accessToken = props.oidc.user.access_token;
    var userName = props.oidc.user.profile.name;
    const canAddGlobalLayout = props.oidc.user?.profile?.ADDGLOBALAYOUT === "Y";
    const [layouts, setLayouts] = useState(["Default"]);
    const [selectedLayout, setSelectedLayout] = useState("Default");
    const [isPublicLayout, setIsPublicLayout] = useState(false);
    const [disableControls, setDisableControls] = useState(false);
    const [addLayoutPopupVisible, setAddLayoutPopupVisible] = useState(false);
    const [isProgrammaticChange, setIsProgrammaticChange] = useState(false);
    const [layoutName, setLayoutName] = useState(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [saveAsGlobalLayout, setSaveAsGlobalLayout] = useState(false);
    const [saveAsGlobalLayoutDefault, setSaveAsGlobalLayoutDefault] = useState(false);

    useEffect(() => {
        if (props.dataGrid?.current) {
          const gridInstance = props.dataGrid.current.instance();
          gridInstance.option('stateStoring.savingTimeout', 200); // Set savingTimeout to 2000ms
        }
      }, []);
    useEffect(() => {
        if (props?.dataGrid?.current) {
            // This component is rendered inside a DevExtreme toolbar template, and devextreme-react
            // tears the template down and rebuilds it whenever the host re-renders. That unmounts us
            // mid-request, so the handlers below must not touch state (or raise a dialog) for a result
            // nobody is waiting for — otherwise React logs "state update on an unmounted component".
            let active = true;
            axios.get(`${window._env_.REACT_APP_APIS}/${data.GridLayout.GetGridLayouts}`,
                {
                    params: {
                        key: props.gridKey
                    },
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    }
                }).then(response => {
                    if (!active) return;
                    if (response.data.success) {
                        setLayouts(response.data.layouts);
                        setIsPublicLayout(response.data.selectedisgloballayout);
                    } else {
                        const errorMessage = response.data.Message || response.data.message || 'Unknown error occurred';
                        alert('Could not load Layouts. ' + errorMessage, 'Error');
                    }
                })
                .catch((error) => {
                    if (!active) return;
                    const errorMessage = error.response?.data?.Message || error.response?.data?.message || error.message || 'Unknown error occurred';
                    alert('Could not load Layouts. ' + errorMessage, 'Error');
                });
            return () => { active = false; };
        }
    }, [props.gridKey, accessToken]);
    useEffect(() => {
        if (selectedLayout === "Default") {
            setDisableControls(true);
        }
    }, [selectedLayout]);
    const saveLayout =async () => {

        if (layoutName == null || layoutName == undefined || layoutName.trim() == "") {
            alert('Name cannot be empty', 'Error');
            return;
        }

        if (layoutName.toLowerCase() === "default") {
            alert('Name cannot be "Default"', 'Error');
            return;
        }
        if (layouts.includes(layoutName)) {
            let iscConfirm = await confirm('A layout with the same name already exists. Do you want to overwrite it?', 'Warning');
            if (!iscConfirm) {
                setAddLayoutPopupVisible(false);
                 return;
            }   
        }
        setLoadPanelVisible(true);
        var requestOptions = {
            key: props.gridKey,
            name: layoutName,
            isNew: true,
            isDefault: false,
            state: JSON.stringify(props?.dataGrid?.current?.instance().state()),
            isGlobalLayout: canAddGlobalLayout && saveAsGlobalLayout,
            isGlobalLayoutDefault: canAddGlobalLayout && saveAsGlobalLayout && saveAsGlobalLayoutDefault
        };

        axios.post(`${window._env_.REACT_APP_APIS}/${data.GridLayout.SaveUpdateGridLayout}`, requestOptions, {
            headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
            },
        })
            .then(response => {
                if (response.data.success) {
                    var layoutsArray = [...layouts];
                    // Remove existing layout with the same name before pushing
                    const index = layoutsArray.indexOf(layoutName);
                    if (index !== -1) {
                        layoutsArray.splice(index, 1);
                    }
                    layoutsArray.push(layoutName);
                    setLayouts(layoutsArray);
                    currentLayout = layoutName;
                    setSelectedLayout(layoutName);
                    setIsPublicLayout(canAddGlobalLayout && saveAsGlobalLayout);
                }
                else {
                    alert(response.data.message, 'Error');
                }
            })
            .catch(() => { throw 'Layout Save/Update Error'; }).finally(()=>{setLoadPanelVisible(false); setAddLayoutPopupVisible(false); setSaveAsGlobalLayout(false); setSaveAsGlobalLayoutDefault(false);});
    }
    const updateDefaultLayout =async (name) => {
        try {
            const requestOptions = {
                key: props.gridKey,
                name: name,
                state: JSON.stringify(props?.dataGrid?.current?.instance().state()),
                isGlobalLayout: false
            };
            await axios.post(
                `${window._env_.REACT_APP_APIS}/${data.GridLayout.UpdateDefaultLayout}`,
                requestOptions,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
        } catch (e) {
            alert('Error updating default layout' + e, 'Error');
        } 
    }
    return (
        <div className="row">
             <LoadPanel
                 shadingColor="rgba(0,0,0,0.4)"
                 position={{ of: '#accordion-containe2' }}
                 onHiding={() => setLoadPanelVisible(false)}
                 visible={loadPanelVisible}
                 showIndicator={true}
                 shading={true}
                 showPane={true}
                 hideOnOutsideClick={false}
             />
            <div className="d-flex justify-content-start align-items-center">
                <SelectBox
                stylingMode='outlined'
                    items={layouts}
                    value={selectedLayout}
                    width={250}
                    style={{ marginRight: "7px" }}
                    onValueChanged={(e) => {
                        setIsProgrammaticChange(true);
                        currentLayout = e.value;
                        props.setCurrentLayout(e.value);
                        setSelectedLayout(e.value);
                        axios.get(`${window._env_.REACT_APP_APIS}/${data.GridLayout.GetGridLayout}`,
                            {
                                params: {
                                    key: props.gridKey,
                                    name: e.value,
                                    isDefault: e.value === "Default" ? true : false,
                                },
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`,
                                }
                            }).then(response => {
                                if (response != null) {
                                    setIsPublicLayout(response.data.isGlobalLayout);
                                    if (response.data.createdBy != userName || response.data.isDefault) {
                                        setDisableControls(true);
                                    }
                                    else {
                                        setDisableControls(false);
                                    }
                                    updateDefaultLayout(e.value);
                                }
                                else {
                                    alert('Could not load Layout ' + e.value, 'Error');
                                }
                            })
                            .catch(() => { throw 'Layout Get Error'; }).finally(() => setIsProgrammaticChange(false));
                    }}
                ></SelectBox>
                {isPublicLayout ? (
                    <DevExtremeButton
                        hint="Public"
                        disabled={disableControls}
                        style={{ marginRight: "6px" }}
                        icon="group"
                        onClick={() => {
                            if (isProgrammaticChange) {
                                return;
                            }
                            setIsPublicLayout(false);
                            props.dataGrid.current.instance().beginCustomLoading("Saving Layout");
                            axios.post(`${window._env_.REACT_APP_APIS}/${data.GridLayout.SaveUpdateGridLayout}`,
                                {
                                    key: props.gridKey,
                                    name: currentLayout,
                                    isDefault: currentLayout === "Default" ? true : false,
                                    isGlobalLayout: false,
                                    state: JSON.stringify(props.dataGrid.current.instance().state())
                                },
                                {
                                    headers: {
                                        "Content-Type": "application/json",
                                        access_token: accessToken,
                                        Authorization: `Bearer ${accessToken}`
                                    }
                                }).then(response => {
                                    props.dataGrid.current.instance().endCustomLoading();
                                    if (!response.data.success) {
                                        alert('Could not Save Layout ' + currentLayout, 'Error');
                                    }
                                })
                                .catch(() => { throw 'Layout Save Error'; });
                        }}
                    />
                ) : (<DevExtremeButton
                    hint="Private"
                    disabled={disableControls}
                    style={{ marginRight: "6px" }}
                    icon="user"
                    onClick={() => {
                        if (isProgrammaticChange) {
                            return;
                        }
                        setIsPublicLayout(true);
                        props.dataGrid.current.instance().beginCustomLoading("Saving Layout");
                        axios.post(`${window._env_.REACT_APP_APIS}/${data.GridLayout.SaveUpdateGridLayout}`,
                            {
                                key: props.gridKey,
                                name: currentLayout,
                                isDefault: currentLayout === "Default" ? true : false,
                                isGlobalLayout: true,
                                state: JSON.stringify(props.dataGrid.current.instance().state())
                            },
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    access_token: accessToken,
                                    Authorization: `Bearer ${accessToken}`
                                }
                            }).then(response => {
                                props.dataGrid.current.instance().endCustomLoading();
                                if (!response.data.success) {
                                    alert('Could not Save Layout ' + currentLayout, 'Error');
                                }
                            })
                            .catch(() => { throw 'Layout Save Error'; });
                    }}
                />)}
                <DevExtremeButton
                style={{ marginRight: "6px" }}
                    icon="save"
                    hint="Save Layout As"
                    onClick={() => {
                        setAddLayoutPopupVisible(true);
                    }}
                ></DevExtremeButton>
                <DevExtremeButton
                    style={{ marginRight: "5px" }}
                    disabled={disableControls}
                    icon="trash"
                    hint="Delete Layout"
                    onClick={() => {
                        GridLayout.deleteGridLayout(props.dataGrid, currentLayout, props.gridKey, accessToken).then((response) => {
                            if (response.deleteskipped != null && response.deleteskipped != undefined && response.deleteskipped == true) {
                                return;
                            }
                            else {
                                if(props?.dataGrid?.current)
                                props.dataGrid.current.instance().endCustomLoading();
                                if (response.success) {
                                    var layoutsArray = [...layouts];

                                    for (var i = 0; i < layoutsArray.length; i++) {
                                        if (layoutsArray[i] === currentLayout) {
                                            layoutsArray.splice(i, 1);
                                            break;
                                        }
                                    }
                                    setLayouts(layoutsArray);
                                    currentLayout = "Default";
                                    setSelectedLayout("Default");
                                }
                                else {
                                    alert(response.message, 'Error');
                                }
                            }
                        }).catch(error => { alert(error, 'Error'); });

                    }}
                ></DevExtremeButton>
                    <div className="separator">
                    </div>
            </div>
            <Popup
                visible={addLayoutPopupVisible}
                onHiding={() => {
                    setAddLayoutPopupVisible(false);
                    setSaveAsGlobalLayout(false);
                    setSaveAsGlobalLayoutDefault(false);
                }}
                dragEnabled={true}
                closeOnOutsideClick={true}
                showCloseButton={true}
                showTitle={true}
                title="Save Layout"
                width={280}
                height={canAddGlobalLayout ? 340 : 250}
            >
                <div style={{ textAlign: "left" }}>
                    <div className='dx-fieldset' style={{ margin: "0px", textAlign: "left" }}>
                        <div className='dx-field'>
                            <div className='dx-field-value' style={{ width: "100%", textAlign: "left" }}>
                                <TextBox
                                    stylingMode='outlined'
                                    labelMode="static"
                                    label="Name"
                                    maxLength={30}
                                    onValueChanged={(e)=>setLayoutName(e.value)}
                                >
                                </TextBox>
                            </div>
                        </div>
                        {canAddGlobalLayout ? (
                        <div style={{ textAlign: "left", margin: 0, padding: 0 }}>
                            <div>
                                <CheckBox
                                    text="Make Global Layout"
                                    value={saveAsGlobalLayout}
                                    onValueChanged={(e) => {
                                        setSaveAsGlobalLayout(e.value);
                                        if (!e.value) {
                                            setSaveAsGlobalLayoutDefault(false);
                                        }
                                    }}
                                />
                            </div>
                            <div>
                                <CheckBox
                                    text="Make Global Layout Default"
                                    value={saveAsGlobalLayoutDefault}
                                    disabled={!saveAsGlobalLayout}
                                    onValueChanged={(e) => setSaveAsGlobalLayoutDefault(e.value)}
                                />
                            </div>
                        </div>
                        ) : null}
                       
                        <div style={{ textAlign: "center", marginTop: "12px" }}>
                            <DevExtremeButton text="Save" type="default" onClick={saveLayout }
                            />
                        </div>
                    </div>
                </div>
            </Popup>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(GridLayoutManager);
